import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Popup from 'reactjs-popup';
import { useDispatch, useSelector } from 'react-redux';

import LocalText from '@/localization/local_text';
import NavData from '@/config/data/nav/nav_data.json';
import { programCategoryList } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import { NEWS_CATEGORY } from '@/reducer';
import useContent from '@/localization/data_export';
import SelectLanguage from './common_header_language';
import './css/common_siteMap.scss';

function CommonSiteMap(props) {
  const { styleK } = props;

  const history = useHistory();
  const dispatch = useDispatch();
  const { mode } = useSelector((state) => state);
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const [listItem] = useAxios(
    programCategoryList,
    [],
    { lan_code: 'ko', program_type: 'news', classify: 'content', is_open_allow: true },
    true
  );
  const { data: categoryData } = listItem;

  const newsSubClick = (name, id) => {
    history.push({ pathname: NavData['NEWS_GENRE'].path, state: { id: id, name: name } });
  };

  return (
    <Popup
      trigger={
        <button className={`btnSiteMap ${styleK ? 'style_black' : ''}`} type="button">
          <p className="sr-only">sitemap open button</p>
          <span className="btnSiteMap_bar"></span>
          <span className="btnSiteMap_bar"></span>
          <span className="btnSiteMap_bar"></span>
        </button>
      }
      modal
      nested
      lockScroll
      overlayStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
      contentStyle={{ position: 'absolute', top: '90px', left: '50%', transform: 'translateX(-50%)' }}
    >
      {(close) => (
        <div id="siteMap" className="siteMap">
          <section className="siteMap_section">
            <div className="content">
              <div className="content_sitemap">
                <div className="content_sitemap_section">
                  <div className="list-wrap">
                    <ul className="left">
                      <li className="list">
                        <Link to={NavData['LIVE_MAIN'].path} className="list_title">
                          <LocalText txt={'menu_live'} />
                        </Link>
                      </li>
                      <li className="list">
                        <Link to={NavData['NEWS_MAIN'].path} className="list_title" title={anchorTitle}>
                          <LocalText txt={'menu_news'} />
                        </Link>
                        <ul className="list_info">
                          {categoryData?.item?.map((v, i) => {
                            if (v.category_id !== 70) {
                              return (
                                <li className="list_info_site" key={i}>
                                  <button
                                    type="button"
                                    className="list_link"
                                    onClick={(name, id) => {
                                      newsSubClick(v?.title, v?.category_id);
                                      dispatch({ type: NEWS_CATEGORY, category: v.title });
                                    }}
                                    title={anchorTitle}
                                  >
                                    {v?.title}
                                  </button>
                                </li>
                              );
                            }
                            return null;
                          })}
                        </ul>
                      </li>
                      <li className="list">
                        <Link to={NavData['TV_MAIN'].path} className="list_title" title={anchorTitle}>
                          <LocalText txt={'menu_tv'} />
                        </Link>
                      </li>
                      <li className="list">
                        <Link to={NavData['RADIO_MAIN'].path} className="list_title" title={anchorTitle}>
                          <LocalText txt={'menu_radio'} />
                        </Link>
                        <ul className="list_info">
                          <li className="list_info_site">
                            <Link to={NavData['RADIO_PODCAST'].path} className="list_link" title={anchorTitle}>
                              PodCast
                            </Link>
                          </li>
                          <li className="list_info_site">
                            <Link to={NavData['RADIO_VOD_MAIN'].path} className="list_link" title={anchorTitle}>
                              VOD
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="list">
                        <Link to={NavData['VOD_MAIN'].path} className="list_title" title={anchorTitle}>
                          <LocalText txt={'menu_vod'} />
                        </Link>
                      </li>
                    </ul>
                    <ul className="right">
                      <li className="list">
                        <span className="list_title">Language</span>
                        <SelectLanguage siteMap={true} />
                      </li>
                      <li className="list">
                        <a
                          href={`https://company.arirang.com/?lang=${mode}`}
                          target="_blank"
                          className="list_title"
                          rel="noreferrer"
                          title={anchorTitle}
                        >
                          About Arirang
                        </a>
                      </li>
                      <li className="list">
                        <Link to={NavData['SCHEDULE'].path} className="list_title" title={anchorTitle}>
                          Schedule
                        </Link>
                      </li>
                      <li className="list">
                        <a
                          href={`https://company.arirang.com/join/watch/?subPage=watch`}
                          target="_blank"
                          rel="noreferrer"
                          className="list_title"
                          title={anchorTitle}
                        >
                          How to Watch
                        </a>
                      </li>
                      <li className="list">
                        <a
                          href={`https://company.arirang.com/join/watch/?subPage=listen`}
                          target="_blank"
                          rel="noreferrer"
                          className="list_title"
                          title={anchorTitle}
                        >
                          How to Listen
                        </a>
                      </li>
                      <li className="list">
                        <a
                          href={`https://company.arirang.com/join/cs`}
                          target="_blank"
                          rel="noreferrer"
                          className="list_title"
                          title={anchorTitle}
                        >
                          FAQ
                        </a>
                      </li>
                      <li className="list">
                        <Link
                          to={NavData['NEWS_REPORTER'].path}
                          className="list_title"
                          onClick={close}
                          title={anchorTitle}
                        >
                          NewsReporter
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <button
            className="closeSitemap"
            onClick={() => {
              close();
            }}
          >
            <p className="sr-only">sitemap close button</p>
            <span className="closeSitemap_bar"></span>
            <span className="closeSitemap_bar"></span>
          </button>
        </div>
      )}
    </Popup>
    // </div>
  );
}

export default CommonSiteMap;
